import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faHourglassHalf, faXmark } from "@fortawesome/free-solid-svg-icons";




const AdminOneEvent = (props) => {
    const token = localStorage.getItem("JWT");

    const [ongletSwitch, setOngletSwitch] = useState(1);           // Gestion Du menu Activité
    const [modalIsOpen, setIsOpen] = React.useState(false);         //gestion de la modal
    const [allStuff, setAllStuff] = useState([]);
    const [allMember, setAllMember] = useState([]);
    const [day, setDay] = useState("");
    const [adminActivite, setAdminActivite] = useState([]);
    const { eventId } = useParams();

    //info relative a un seul membre
    const [displayinfoMembre, setDisplayInfoMembre] = useState(false); // afficher ou non les infos membres
    const [infoMembrePseudo, setInfoMembrePseudo] = useState("");
    const [infoMembrePP, setInfoMembrePP] = useState("");
    const [infoMembreRang, setInfoMembreRang] = useState("");

    //info relative a l'event
    const [titre, setTitre] = useState("");
    const [jour, setJour] = useState("");
    const [date, setDate] = useState("");
    const [heure, setHeure] = useState("");
    const [description, setDescription] = useState("");
    const [responsables, setResponsables] = useState([]);
    const [inscrits, setInscrits] = useState([]);
    const [PRV, setPRV] = useState("");
    const [PP, setPP] = useState("");
    const [UEC, setUEC] = useState("");
    const [warbonds, setWarbonds] = useState("");
    const [type, setType] = useState("");
    const [logo, setLogo] = useState("");
    const [recompense, setRecompense] = useState(null);
    const [activiteCompteur, setActiviteCompteur] = useState("");
    const [inscritLength, setInscritLength] = useState(0);
    const [inscritRangArray, setInscritRangArray] = useState([]);
    const [eventType, setEventType] = useState("");
    const [eventGenre, setEventGenre] = useState("");

    //gestion du timer de l'event dynamique
    const [timeElapsed, setTimeElapsed] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const [intervalId, setIntervalId] = useState(null);
    const [isEventFinish, setIsEventFinish] = useState(false);
    const [startEventTime, setStartEventTime] = useState();
    const [endEventTime, setEndEventTime] = useState();



    function getAllUsers() {          // recupère tout les membres FCU pour définir un responsable
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/userEncadrement`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },

        })
            .then((res) => {
                const membresFiltres = res.data.filter((membre) => {
                    if (membre.encadrements) {
                        return membre.encadrements.some((encadrement) => encadrement.priorite >= 2);
                    }
                    return false;
                });

                setAllMember(membresFiltres)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const changeResponsable = (e) => {
        let selectArray = document.querySelectorAll(".adminEventResponsable")

        let newResponsableArray = [];
        selectArray.forEach(select => {
            if (select.value) {
                newResponsableArray.push(select.value);
            }
        });

        // Retirer les doublons du tableau responsableArray
        newResponsableArray = [...new Set(newResponsableArray)];

        // Filtrer les valeurs vides
        newResponsableArray = newResponsableArray.filter(item => item !== "");

        const selectedOption = e.target.selectedOptions[0];
        let activiteId = selectedOption.getAttribute("data")

        axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/changeResponsable`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
            data: {
                activiteId,
                newResponsableArray,
            }
        })
            .then((res) => {
                toast.success("Responsable modifié!");
            })
            .catch((err) => {
                console.log(err);
                toast.error("Erreur lors du changement de responsable!");
            })
    }

    const handleSelectChange = (e) => { //changement de couleur du select
        let focus = e.target;
        focus.classList.add("selected-option")
    };

    function modifyActivite(e) {
        e.preventDefault()

        let activiteId = document.querySelector('.adminEvent__admin__activiteContainer__activite')
        activiteId = activiteId.id

        let titre = document.querySelector(".adminEventTitre").value
        let PRV = document.querySelector(".adminEventPrv").value
        let responsable = document.querySelector(".adminEventResponsable").value
        let type = document.querySelector(".adminEventType").value
        let description = document.querySelector(".adminEventDescription").innerText
        let PP = document.querySelector(".adminEventPP").value
        let warbond = document.querySelector(".adminEventWarbond").value

        // console.log(titre);
        // console.log(PRV);
        // console.log(responsable);
        // console.log(type);
        // console.log(description);
        // console.log(PP);
        // console.log(warbond);

        axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL}api/modifyActivite`,
            data: {
                activiteId,
                titre,
                PRV,
                responsable,
                type,
                description,
                PP,
                warbond,
            }
        })
            .then((res) => {
                toast.success("Activité modifié!");

            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response.data.message);

            })
    }

    //-----------------------------------------------------Intéraction avec l'event---------------------------------------------------------//

    const deleteInscription = (e) => {      //retire un joueur des inscrits
        e.stopPropagation()
        setDisplayInfoMembre(false)
        let focus = e.target
        let focusParent = focus.parentElement

        let userId = focus.id
        let compteur = focus.getAttribute("activitecompteur")

        confirmAlert({
            title: "Retirer ce joueur de l'event!",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        axios({
                            method: "delete",
                            url: `${process.env.REACT_APP_API_URL}api/deleteMemberInscription`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },
                            data: {
                                userId,
                                compteur
                            }

                        })
                            .then((res) => {
                                focusParent.remove()
                                setInscritLength(inscritLength - 1)

                            })
                            .catch((err) => {
                                console.log(err);
                            })
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });

    }

    const abordMission = (e) => {

        let activiteId = eventId


        confirmAlert({
            title: "Annuler l'event en cour?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {

                        axios({
                            method: "delete",
                            url: `${process.env.REACT_APP_API_URL}api/abordMission`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },
                            data: {
                                activiteId,
                            }
                        })
                            .then((res) => {
                                toast.success("Event annulé!");
                                window.location = `/adminWIP`;


                            })
                            .catch((err) => {
                                toast.error("Erreur lors de l'annulation de l'event'!");

                            })
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });
    }

    const exportAdminFunction = (resultat) => {

        let activiteId = eventId

        confirmAlert({
            title: "Valider l'admin de cet event?",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {

                        axios({
                            method: "post",
                            url: `${process.env.REACT_APP_API_URL}api/adminActivite`,
                            headers: {
                                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                            },
                            data: {
                                activiteId,
                                resultat
                            }
                        })
                            .then((res) => {
                                toast.success("Merci pour l'admin!");
                                window.location = `/adminEvent`;
                            })
                            .catch((err) => {
                                toast.error("Erreur lors de l'admin!");
                            })
                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });
    }

    const admin = (e) => {      //Admin d'un activité

        if (eventType === "Event inter Orga") {
            const radios = document.getElementsByName('resultat');
            let resultat;
            for (const radio of radios) {
                if (radio.checked) {
                    resultat = radio.value;
                    break;
                }
            }

            if (!resultat) {
                toast.error("Résultat de l'event a définir");
            } else {
                exportAdminFunction(resultat)
            }


        } else {
            let resultat = null
            exportAdminFunction(resultat)
        }
    }

    //-----------------------------------------------------affichage de données---------------------------------------------------------//

    const createEffectifArray = (allInscriptionsArray) => {

        // Création d'un tableau avec tous les rangs et leurs priorités
        let rangsArray = [];
        allInscriptionsArray.forEach(element => {
            rangsArray.push({ nom: element.rang.nom, priorite: element.rang.priorite });
        });

        // Créer un objet pour compter le nombre de chaque rang
        let rangsCount = {};
        rangsArray.forEach(element => {
            if (rangsCount[element.nom]) {
                rangsCount[element.nom]++;
            } else {
                rangsCount[element.nom] = 1;
            }
        });

        // Trier rangsArray par priorité
        rangsArray.sort((a, b) => a.priorite - b.priorite);

        // Utiliser un Set pour supprimer les doublons et conserver l'ordre trié
        let uniqueRangsSet = new Set();
        let uniqueRangsArray = [];

        rangsArray.forEach(element => {
            if (!uniqueRangsSet.has(element.nom)) {
                uniqueRangsSet.add(element.nom);
                uniqueRangsArray.push({ nom: element.nom, count: rangsCount[element.nom] });
            }
        });

        // Appeler la fonction pour mettre à jour l'état
        setInscritRangArray(uniqueRangsArray);
    }

    const infoMembre = (e) => {
        let membrePseudo = e.target.innerText
        let membreRang = e.target.getAttribute('data-rang');
        let membrePP = e.target.getAttribute('data-pp');

        setDisplayInfoMembre(true)
        setInfoMembreRang(membreRang)
        setInfoMembrePseudo(membrePseudo)
        setInfoMembrePP(membrePP)
    }

    const getOneEvent = (e) => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/oneActivite/${eventId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            },
        })
            .then((res) => {
                // console.log(res.data);
                setTitre(res.data.titre)
                setJour(res.data.jour)
                setDate(res.data.date)
                setHeure(res.data.heure)
                setDescription(res.data.description)
                setResponsables(res.data.responsables)
                setInscrits(res.data.inscriptions)
                setPRV(res.data.PRV)
                setPP(res.data.PP)
                setWarbonds(res.data.warbond)
                setUEC(res.data.UEC)
                setType(res.data.type)
                setLogo(res.data.logo)
                setRecompense(res.data.recompense)
                setActiviteCompteur(res.data.compteur)
                setInscritLength(res.data.inscriptions.length)
                setEventType(res.data.type)
                setEventGenre(res.data.genre)
                setStartEventTime(res.data.debut)
                setEndEventTime(res.data.fin)

                // appelle de la fonction pour création du tableau des effectifs
                createEffectifArray(res.data.inscriptions)

                //lancer le timer si l'activité a deja commencé
                if (res.data.debut) {
                    startTimer(res.data.debut)
                }

                if (res.data.debut && res.data.fin) {
                    setIsEventFinish(true)

                }


            })
            .catch((err) => {
            })
    }

    //-----------------------------------------------------Calculs event dynamique---------------------------------------------------------//

    const startTimer = (eventDebut) => {

        if (!isRunning) {
            let start

            if (isNaN(eventDebut)) {
                confirmAlert({
                    title: "Démarrer l'event dynamique !",
                    message: "Etes vous sûr?",
                    buttons: [
                        {
                            label: "Oui",
                            onClick: () => {
                                start = Date.now();
                                setStartEventTime(start)

                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/startEvent`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    },
                                    data: {
                                        activiteId: eventId,
                                        start
                                    }

                                })
                                    .then((res) => {
                                        toast.success("l'event dynamique est lancé");
                                        setIsRunning(true)
                                        const id = setInterval(() => {
                                            setTimeElapsed(Date.now() - start);
                                        }, 1000);

                                        setIntervalId(id);

                                    })
                                    .catch((err) => {
                                        console.log(err);
                                        toast.error(err.response.data.message);

                                    })
                            },
                        },
                        {
                            label: "Non",
                            onClick: () => {

                            },
                        },
                    ],
                });


            } else {

                start = eventDebut;
                setStartEventTime(start)
                setIsRunning(true)
                const id = setInterval(() => {
                    setTimeElapsed(Date.now() - start);
                }, 1000);

                setIntervalId(id);
            }


        }
    };

    const stopTimer = () => {

        if (isRunning) {

            confirmAlert({
                title: "Stopper l'event dynamique? Vous ne pourrez pas revenir en arrière.",
                message: "Etes vous sûr?",
                buttons: [
                    {
                        label: "Oui",
                        onClick: () => {
                            let end = Date.now();
                            setEndEventTime(end)

                            axios({
                                method: "post",
                                url: `${process.env.REACT_APP_API_URL}api/finishEvent`,
                                headers: {
                                    Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                },
                                data: {
                                    activiteId: eventId,
                                    end
                                }

                            })
                                .then((res) => {
                                    toast.success("l'event dynamique est terminé");
                                    clearInterval(intervalId);
                                    setIsRunning(false);
                                    setIsEventFinish(true)
                                })
                                .catch((err) => {
                                    console.log(err);
                                    toast.error(err.response.data.message);
                                })

                        },
                    },
                    {
                        label: "Non",
                        onClick: () => {

                        },
                    },
                ],
            });
        }
    };

    const formatTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const calculateElapsedTime = (e) => {  // calculer le temps totale de l'event
        const startTimestamp = startEventTime;
        const endTimestamp = endEventTime;

        const elapsedMilliseconds = endTimestamp - startTimestamp;

        const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const finDeService = (e) => {
        e.stopPropagation()

        confirmAlert({
            title: "Fin de service pour ce joueur.",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        let focus = e.target
                        let userId = focus.getAttribute("userid")

                        axios({
                            method: "post",
                            url: `${process.env.REACT_APP_API_URL}api/finDeService`,
                            data: {
                                activiteId: eventId,
                                userId
                            }

                        })
                            .then((res) => {
                                toast.success("Fin de service pour ce joueur")
                            })
                            .catch((err) => {
                                console.log(err);
                                toast.error(err.response.data.message);

                            })

                    },
                },
                {
                    label: "Non",
                    onClick: () => {

                    },
                },
            ],
        });
    }

    useEffect(() => {
        getOneEvent()

        // Clean up interval on component unmount
        // return () => clearInterval(intervalId);
    }, []);



    return (
        <div className='adminOneEvent'>
            <Link className='exitButton' to="/profil"><FontAwesomeIcon icon={faArrowLeft} /></Link>

            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />

            <div className='adminOneEvent__container'>

                <div className='adminOneEvent__container__top' >
                    <div className='logoCont'>
                        <img src={logo} alt='logo de la branche ' />
                    </div>
                    <div className='titleCont'>
                        <span>
                            <h2>{titre}</h2>
                            <h4>{jour}  {date} a {heure}</h4>
                        </span>
                        <p>{description}</p>
                    </div>
                </div>

                <div className='adminOneEvent__container__bottom' >

                    <div className='OneEventLeft'>

                        <span className='responsablesInfo'>
                            <p className='marginRight'>{responsables.length > 1 ? "Responsables:" : "Responsable:"} </p>
                            {responsables.map((responsable, index) => (
                                <p key={responsable.discordID} id={responsable.discordID}>{index !== 0 && ', '}{responsable.pseudoFCU}</p>
                            ))}
                        </span>
                        <span>
                            <p>type d'event: {type}</p>
                        </span>
                        <span>
                            <p>PRV: {PRV}</p>
                        </span>
                        <span>
                            <p>PP: {PP}</p>
                        </span>
                        <span>
                            <p>UEC: {UEC}</p>
                        </span>
                        <span>
                            <p>Warbonds: {warbonds}</p>
                        </span>
                        <span>
                            <p>Récompense: {recompense ? `oui` : "aucune"}</p>
                        </span>

                    </div>

                    <div className='OneEventMiddle'>

                        <fieldset className='infoInscritOnClick'>
                            <legend>Info membre:</legend>
                            {displayinfoMembre === true ?
                                <div className='infoMembreCont'>
                                    <h3 className='infoMembreCont__pseudo'>{infoMembrePseudo}</h3>
                                    <p>{infoMembreRang}</p>
                                    <p>{infoMembrePP} PP</p>
                                </div>
                                :
                                <p>Cliquez sur un joueur pour en savoir plus sur lui.</p>
                            }

                        </fieldset>

                        <div className='infoEventContainer'>

                            <fieldset className='effectifEvent'>
                                <legend>Effectif et force de frappe:</legend>
                                <span className='inscritsCount'>
                                    <h3 className='numberInscritsCount'>{inscritLength}</h3>
                                    <h3>Joueurs inscrits</h3>
                                </span>
                                <span className='rangsCount'>
                                    {inscritRangArray.map((rangs, index) => (
                                        <span key={rangs.nom} id={rangs.nom}>
                                            <p className='rangsCountNumber'>{rangs.count}</p>
                                            <p>{rangs.nom}</p>
                                        </span>
                                    ))}
                                </span>

                            </fieldset>

                            <fieldset className='interactionsEvent'>
                                <legend>Intéractions avec l'event:</legend>
                                {eventType === "Event inter Orga" &&

                                    <fieldset className='resultatEvent'>
                                        <input
                                            type="radio"
                                            id="victoire"
                                            value="victoire"
                                            name="resultat"
                                            required
                                        />
                                        <label htmlFor="victoire">Victoire</label>

                                        <input
                                            type="radio"
                                            id="egalite"
                                            value="egalite"
                                            name="resultat"
                                            required
                                        />
                                        <label htmlFor="egalite">Égalité</label>

                                        <input
                                            type="radio"
                                            id="defaite"
                                            value="defaite"
                                            name="resultat"
                                            required
                                        />
                                        <label htmlFor="defaite">Défaite</label>

                                    </fieldset>

                                }
                                {eventGenre === "dynamique" &&
                                    <>
                                        {isEventFinish ?
                                            <div>
                                                <h1>Timer: {calculateElapsedTime()}</h1>
                                            </div>

                                            :
                                            <div>
                                                <h1>Timer: {formatTime(timeElapsed)}</h1>
                                                <button onClick={startTimer} disabled={isRunning}>Start Timer</button>
                                                <button onClick={stopTimer} disabled={!isRunning}>Stop Timer</button>
                                            </div>
                                        }
                                    </>
                                }

                            </fieldset>
                        </div>

                        <div className='interactionButton'>
                            <button className='annulationAdminButton' onClick={abordMission}>Annulation</button>
                            <button className='validationAdminButton' onClick={admin}>Admin</button>
                        </div>

                    </div>

                    <div className='OneEventRight'>
                        <div className='inscriptionCont'>
                            <h3>Inscriptions:</h3>
                            <div className='inscriptionList'>
                                {inscrits.map((inscrit, index) => (
                                    <p className='allInscrits' key={inscrit.discordID} data-rang={inscrit.rang.nom} data-pp={inscrit.PP} onClick={infoMembre}>
                                        {inscrit.pseudoFCU}
                                        < FontAwesomeIcon activitecompteur={activiteCompteur} id={inscrit.discordID} onClick={deleteInscription} icon={faXmark} />
                                        {eventGenre === "dynamique" &&
                                            < FontAwesomeIcon userid={inscrit.id} onClick={finDeService} icon={faHourglassHalf} />
                                        }
                                    </p>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    );
};

export default AdminOneEvent;